import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPrasarana = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPrasarana = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "20px",
          }}
        >
          <div>LAMPIRAN 7</div>
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN PRASARANA, SARANA & UTILITAS PERUMAHAN
        </div>
        <div style={{ marginTop: "10px", height: "2px", width: "100%", backgroundColor: "black", marginBottom: "10px" }}></div>
        <div style={{ padding: "20px" }}>
          <p>Yang bertanda tangan di bawah ini :</p>

          <table style={{ marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                <td style={{ width: "120px" }}>Nama </td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Tempat/tgl lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>No. KTP/NIK</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginLeft: "20px" }}>Selaku calon debitur.</div>
          <table>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "20px" }}></td>
                <td style={{ width: "120px" }}>Nama </td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Tempat/tgl lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>
                  {" "}
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? "-"}
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>No. KTP/NIK</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.identity_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.address_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginLeft: "20px" }}>Selaku suami/istri *) pemohon.</div>

          <div style={{ marginTop: "20px" }}>Menyatakan hal-hal sebagai berikut:</div>
          <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                  <td style={{ verticalAlign: "top" }}>
                    Saya telah mempertimbangkan dengan baik dan tanpa paksaan dari pihak manapun sebelum memutuskan untuk membeli 1 (satu) unit Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) dari pengembang/developer <span style={{ fontWeight: "bold" }}>{companyName}</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                  <td style={{ verticalAlign: "top" }}>
                    {" "}
                    aya telah mengetahui dan bersedia menerima kondisi Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) beserta dengan kondisi Prasarana, Sarana dan Utilitas (PSU) dengan rincian sebagai berikut: <br />
                    3.1. Telah ada bukti pembayaran biaya penyambungan listrik dari PLN. <br />
                    3.2. Telah tersedia sumber air yang berfungsi. <br />
                    3.3. Badan jalan telah dilakukan pengerasan. <br />
                    3.4. Saluran/drainase lingkungan telah selesai dan berfungsi.
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                  <td style={{ verticalAlign: "top" }}>Saya tidak akan mengkaitkan kondisi Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) Prasarana, Sarana dan Utilitas (PSU) dengan kewajiban pembayaran angsuran KPR BTN Bersubsidi </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
              }}
            >
              <div>Menyetujui,</div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
              }}
            >
              <div>
                Bogor, ................................
                <br />
                Yang membuat pernyataan,
              </div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
              }}
            >
              <div>ANGGA BUDI KUSUMA</div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "168px",
              }}
            >
              <div>{item.sls_appl?.name ?? "-"}</div>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>*) Pilih salah satu</div>
        </div>
      </div>
    </div>
  );
};
